import { MutationType } from '@tencent/slide-sdk-pb-model';
import { assert } from 'ts-essentials';
import { BaseMutation } from '../base/base-mutation';
import { Rule } from '../base/mutation-rules';
import { DataType } from '../../data';
import type { PresentationDataModel } from '../../model/presentation-data-model';
import type { MaybeError } from '../base/base-mutation';
import type { IValidMoveShapeMutationData } from '../base/valid-mutation-data';

export class MoveShapeMutation extends BaseMutation<PresentationDataModel, IValidMoveShapeMutationData> {
    public readonly type: MutationType = MutationType.MoveShape;

    public apply(presentation: PresentationDataModel) {
        const { srcParentId, destParentId, srcIndex, destIndex } = this.data;

        const srcGroupShape = presentation.store.models.get(srcParentId, DataType.GroupShape);
        assert(srcGroupShape, 'group shape should not exist');
        if (srcParentId === destParentId) {
            srcGroupShape.store.shapeList.move(srcIndex, destIndex);
        } else {
            const destGroupShape = presentation.store.models.get(destParentId, DataType.GroupShape);
            assert(destGroupShape, 'dest group shape should not exist');
            const shape = srcGroupShape.store.shapeList.at(srcIndex);
            srcGroupShape.store.shapeList.transferTo(destGroupShape.store.shapeList, srcIndex, destIndex, 1);
            shape.parent = destGroupShape;
        }
    }

    public invert(): [IValidMoveShapeMutationData] {
        const { pageId, shapeId, srcParentId, destParentId, srcIndex, destIndex } = this.data;

        return [
            {
                type: MutationType.MoveShape,
                pageId,
                shapeId,
                srcParentId: destParentId,
                destParentId: srcParentId,
                srcIndex: destIndex,
                destIndex: srcIndex,

                // TODO: 删除 deprecated 的字段
                opType: 0,
                destShapeId: '',
            },
        ];
    }

    public check(presentation: PresentationDataModel): MaybeError {
        const { pageId, shapeId, srcParentId, destParentId, srcIndex, destIndex } = this.data;
        return Rule.every(
            Rule.shape.should.existInPage(presentation, shapeId, pageId),
            Rule.shape.should.existInPage(presentation, srcParentId, pageId),
            Rule.shape.should.existInPage(presentation, destParentId, pageId),
            Rule.shape.should.matchShapeListInPosition(presentation, srcParentId, srcIndex, [shapeId]),
            Rule.groupShape.can.insertShapeToPosition(presentation, destParentId, destIndex, shapeId),
        );
    }
}
